import BasePolicy from '@/policies/BasePolicy.js';

export default class QuizPolicy extends BasePolicy {
    /**
     * @param {User} user
     * @param {Quiz} quiz
     * @returns boolean
     */
    viewAny(user) {
        return user.hasPermissionTo('view all quizzes') || user.hasGroupPermissionTo('view all quizzes');
    }

    /**
     * @param {User} user
     * @param {Quiz} quiz
     * @returns boolean
     */
    view(user, quiz) {
        return user.hasPermissionTo('view a quiz') || user.hasGroupPermissionTo('view a quiz');
    }

    viewReport(user, quiz) {
        const hasGroupPermission = user.hasGroupPermissionTo('view quiz report') && user.isInAssetGroup(quiz);

        return user.hasPermissionTo('view quiz report') || hasGroupPermission;
    }

    /**
     * @param {User} user
     * @param {Course} course
     * @returns boolean
     */
    create(user, course) {
        return user.hasPermissionTo('create a quiz') || user.hasGroupPermissionTo('create a quiz');
    }

    /**
     * @param {User} user
     * @param {Quiz} quiz
     * @returns boolean
     */
    update(user, quiz) {
        if (quiz.locked_for_editing && !user.hasPermissionTo('edit a locked quiz')) {
            return false;
        }

        const hasGroupPermission = user.hasGroupPermissionTo('edit a quiz') && user.isInAssetGroup(quiz);

        return user.hasPermissionTo('edit a quiz') || hasGroupPermission;
    }

    /**
     * @param {User} user
     * @param {Quiz} quiz
     * @returns boolean
     */
    updateSurvey(user, quiz) {
        if (quiz.locked_for_editing && !user.hasPermissionTo('edit a locked quiz')) {
            return false;
        }

        const hasGroupPermission = user.hasGroupPermissionTo('edit a survey') && user.isInAssetGroup(quiz);

        return user.hasPermissionTo('edit a survey') || hasGroupPermission;
    }

    /**
     * @param {User} user
     * @param {Quiz} quiz
     * @returns boolean
     */
    delete(user, quiz) {
        if (quiz.locked_for_editing && !user.hasPermissionTo('edit a locked quiz')) {
            return false;
        }

        return user.hasPermissionTo('delete a quiz') || user.hasGroupPermissionTo('delete a quiz');
    }

    /**
     * @param {User} user
     * @param {Quiz} quiz
     * @returns boolean
     */
    archive(user, quiz) {
        return user.hasPermissionTo('archive a quiz') || user.hasGroupPermissionTo('archive a quiz');
    }
}
